import { render, staticRenderFns } from "./BoardPreview.vue?vue&type=template&id=31759d2f&scoped=true"
import script from "./BoardPreview.vue?vue&type=script&lang=js"
export * from "./BoardPreview.vue?vue&type=script&lang=js"
import style0 from "./BoardPreview.vue?vue&type=style&index=0&id=31759d2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31759d2f",
  null
  
)

export default component.exports